import { useTranslation } from 'react-i18next';
import { loginRefusalMessage } from 'helpers/loginRefusal';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './Login.module.css';
import { UserContext } from 'context/userContext';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

interface Props {
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const Login = ({ setModalOpen }: Props) => {
  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { login } = useContext(UserContext);

  const formSubmitHandler = async (formData: any) => {
    const userInfo = await login(formData.username, formData.password);
    if (formData.username && formData.password && userInfo) {
      if (!userInfo.has_logged_in_before) {
        navigate('/change-password');
      }
      setModalOpen(false);
    } else {
      setError('wrong-credential', {
        message: loginRefusalMessage(t, i18n.language),
      });
      reset();
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div>
          <ThemeIcon icon="person" alt="Login" variant="inline" />
          {t('login_label')}
        </div>
        <ThemeIcon
          icon="remove-black"
          alt="Close"
          variant="inline"
          onClick={() => setModalOpen(false)}
        />
      </div>
      <div className={styles.errorMessage}>
        {Object.keys(errors).length > 0 &&
          String(errors['wrong-credential']?.message ?? t('wrong_credentials'))}
      </div>
      <form className={styles.form} onSubmit={handleSubmit(formSubmitHandler)}>
        <input
          type="text"
          placeholder="Username"
          {...register('username', { required: true })}
        />
        <input
          type="password"
          placeholder="●●●●●●●●●●"
          {...register('password', { required: true })}
        />
        <input type="submit" value={t('login_label')} />
      </form>
      <div className={styles.belowForm}>
        <div className={styles.forgotLinks}>
          <span>{t('forgot_username')}</span>
          <span>{t('forgot_password')}</span>
        </div>
        <div className={styles.createAccount}>
          <span>{t('user_has_account_question')}</span>
          <div>{t('open_account_now_label')}</div>
        </div>
      </div>
    </div>
  );
};
